import React, { useState, useRef, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { getUnitsPromotion, sendDataForm, updateFormPromotion, updateImages, getUnitsWhithPromo, updateUnitsWhithPromo } from './integracion';
import ModalPromocion from './ModalPromocion/ModalPromocion';
import ModaleditPromo from './ModalPromocion/ModaleditPromo';

const ullImages = process.env.REACT_APP_LANDING_IMAGES
export default function AdministradorPromociones() {
    const [globalFilter, setGlobalFilter] = useState('');
    const [productos, setProductos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalVisibleEdit, setModalVisibleEdit] = useState(false);
    const [selectedProducto, setSelectedProducto] = useState(null);
    const [updateTable, setUpdateTable] = useState(null);
    const [unidadesAsiganadas, setUnidadesAsiganadas] = useState([]);
    const dt = useRef(null);
    useEffect(() => {
        getUnitsWhithPromo().then(data => {
            setUnidadesAsiganadas(data)
        }).catch(error => {
            console.log("error", error);
        })
    }, [updateTable]);
    useEffect(() => {
        getUnitsPromotion(setProductos);
    }, [updateTable]);

    const estatusTemplate = (rowData) => {
        return (
            <div className="flex items-center gap-2">
                {rowData.ACTIVO ? (
                    <i className="pi pi-check" style={{ fontSize: '1.15rem', color: "#1ccf1c" }}></i>
                ) : (
                    <i className="pi pi-times" style={{ fontSize: '1.15rem', color: "red" }}></i>
                )}
            </div>
        );
    };


    const fotoTemplate = (rowData) => {
        return (
            <img
                width={'100%'}
                src={`${ullImages}${rowData.IMAGEN_BANER}`}
                alt={`promo-${rowData.ID}`}
                className="w-28 h-14 object-cover rounded shadow-sm"
            />
        )
    }

    const editarTemplate = (rowData) => {
        const onEdit = () => {
            setSelectedProducto(rowData);
            setModalVisibleEdit(true);
        };

        return (
            <div className="flex gap-2">
                <Button icon="pi pi-pencil" className="p-button-sm p-button-rounded" aria-label="Editar" onClick={onEdit} />
            </div>
        );
    };
    const ShowTemplate = (rowData) => {

        function abrirNuevaPestana(url) {
            window.open(url, '_blank');
        }
        return (
            <div className="flex gap-2">
                <Button icon="pi pi-eye" className="p-button-sm p-button-rounded" aria-label="Editar" onClick={() => { abrirNuevaPestana(`https://promociones.sumaenlinea.mx/?IUP=${rowData.ID}`) }} />
            </div>
        );
    };

    const header = () => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div className="p-input-icon-left">
                    <InputText
                        value={globalFilter}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Buscar..."
                        className="w-64"
                    />
                </div>
                <Button onClick={() => { setModalVisible(true); }}>+</Button>
            </div>
        )
    }



    const handleModalSubmitEdit = async (data) => {
        await updateFormPromotion(data, setUpdateTable, updateTable)

        const payload = {
            id: Number(selectedProducto?.ID),
            units: (data?.unidades || []).map((unit) => Number(unit))
        }
        await updateUnitsWhithPromo(payload, setUpdateTable, updateTable)
    };

    const handleApplyUnitsEdit = async (payload) => {
        const params = {
            id: Number(payload?.id),
            units: (payload?.units || []).map((unit) => Number(unit))
        }

        await updateUnitsWhithPromo(params, setUpdateTable, updateTable)
    }

    const handleModalSubmit = async (data) => {
        
        const id = await sendDataForm(data?.campos)
        await updateImages(data?.images, id, setUpdateTable, updateTable)
        
        const params = {
            id: Number(id),
            units: (data?.unidades || []).map((unit) => Number(unit))
        }
        await updateUnitsWhithPromo(params, setUpdateTable, updateTable)
    };
    return (
        <div className="p-4">
            <div className="card">
                <DataTable
                    ref={dt}
                    value={productos}
                    paginator
                    rows={10}
                    rowsPerPageOptions={[5, 10, 25]}
                    header={header}
                    globalFilter={globalFilter}
                    emptyMessage="No se encontraron registros"
                    className="shadow-md"
                >
                    <Column field="ID" header="ID" sortable style={{ width: '80px' }} />
                    <Column field="PROMO" header='PROMO' style={{ width: '140px' }} />
                    <Column header="FOTO" body={fotoTemplate} style={{ width: '140px' }} />
                    <Column field="TITULO_BANNER" header="TITULO DEL BANNER" />
                    <Column field="FECHA" header="FECHA" sortable />
                    <Column header="ACTIVO" body={estatusTemplate} style={{ width: '220px' }} />
                    <Column field ='ESCANEOS' header="ESCANEOS"  style={{ width: '220px' }} />
                    <Column field ='UNIDADES_ASIGNADAS' header="UNIDADES"  style={{ width: '220px' }} />
                    <Column header="EDITAR" body={editarTemplate} style={{ width: '140px' }} />
                    <Column header="VER" body={ShowTemplate} style={{ width: '140px' }} />
                </DataTable>
            </div>

            {modalVisible && (
                <ModalPromocion
                    visible={modalVisible}
                    onHide={() => { setModalVisible(false) }}
                    onSave={handleModalSubmit}
                    data={selectedProducto}
                    unidadesAsiganadas = {unidadesAsiganadas}
                />
            )}
            {modalVisibleEdit && (
                <ModaleditPromo
                    visible={modalVisibleEdit}
                    onHide={() => { setModalVisibleEdit(false) }}
                    onSave={handleModalSubmitEdit}
                    id_promo={selectedProducto?.ID}
                    unidadesAsiganadas={unidadesAsiganadas}
                    onApplyUnits={handleApplyUnitsEdit}
                />
            )}
        </div>
    );
}
